import React from "react"

export const isReactSnap = window?.navigator.userAgent === "ReactSnap"

export const DisablePrerender: React.FC = ({ children }) => (isReactSnap ? <></> : <>{children}</>)
